import { render } from "./mall.vue?vue&type=template&id=69b67e6c&scoped=true"
import script from "./mall.vue?vue&type=script&lang=js"
export * from "./mall.vue?vue&type=script&lang=js"

import "./mall.vue?vue&type=style&index=0&id=69b67e6c&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b67e6c"]])

export default __exports__